import * as yup from 'yup'
import { modulesType } from '../constants/modules'

export const createQuestionValidation = (type, length, { timer }, options = {}) => {
  if (!length) {
    throw new Error("Lenght Must be fullfield, example '5'")
  }
  if (typeof length !== 'number') {
    throw new Error('Length must be number!')
  }

  switch (type) {
    case modulesType.MULTIPLE:
      return validationMultiQuestion(length, { timer, options })

    case modulesType.ESSAY_LENGTH:
      return validationEssayQuestion(length, { timer }, { options })

    case modulesType.DISC:
      return validationDiscQuestion(length, { timer })

    case modulesType.ESAI_FREE_TEXT:
      return validationEssayFreeTextQuestion(length, { timer })

    case modulesType.SOAL_ONLY:
      return yup.object().shape({})

    case modulesType.DESCRIPTION_ONLY:
      return yup.object().shape({})

    case modulesType.NUMBER_CHOICE:
      return validationNumberChoiceQuestion(length, { timer })

    default:
      return validationMultiQuestion(length, { timer })
  }
}

const validationMultiQuestion = (length, { timer }) => {
  const validate = {}
  for (let i = 1; i <= length; i++) {
    if (timer.minutes === 0 && timer.seconds < 1) {
      validate[`question_${i}`] = yup.string()
    } else {
      validate[`question_${i}`] = yup.string().required('Pilih salah satu jawaban')
    }
  }
  return yup.object().shape({
    ...validate,
  })
}

const validationEssayQuestion = (length = 6, { timer }, { options }) => {
  const validate = {}
  for (let i = 1; i <= length; i++) {
    if (timer.minutes === 0 && timer.seconds < 1) {
      validate[`question_${i}`] = yup.number()
    } else {
      validate[`question_${i}`] = yup
        .number()
        .min(1, 'Value tidak boleh kurang dari 1')
        .max(Number(options.maxNumber), `Value tidak boleh lebih dari ${options.maxNumber}`)
        .required('Pilih range jawaban')
        .typeError('Silahkan tuliskan range angka')
    }
  }
  return yup.object().shape({
    ...validate,
  })
}

const validationEssayFreeTextQuestion = (length = 6, { timer }) => {
  const validate = {}
  for (let i = 1; i <= length; i++) {
    if (timer.minutes === 0 && timer.seconds < 1) {
      validate[`question_${i}`] = yup.string()
    } else {
      validate[`question_${i}`] = yup.string().trim().required('Tidak boleh kosong')
    }
  }
  return yup.object().shape({
    ...validate,
  })
}

const validationDiscQuestion = (length, { timer }) => {
  const validate = {}
  for (let i = 1; i <= length; i++) {
    if (timer.minutes === 0 && timer.seconds < 1) {
      validate[`p${i}`] = yup.string()
      validate[`k${i}`] = yup.string()
    } else {
      validate[`p${i}`] = yup.string().required('Pilih salah satu jawaban P')
      validate[`k${i}`] = yup.string().required('Pilih salah satu jawaban K')
    }
  }
  return yup.object().shape({
    ...validate,
  })
}

const validationNumberChoiceQuestion = (length, { timer }) => {
  const validate = {}
  for (let i = 1; i <= length; i++) {
    if (timer.minutes === 0 && timer.seconds < 1) {
      validate[`question_${i}`] = yup.string()
    } else {
      validate[`question_${i}`] = yup.string().required('Angka tidak boleh kosong')
    }
  }
  return yup.object().shape({
    ...validate,
  })
}
